import { translate } from "app/filters/i18nFilter";

import { KEYWORD_GROUP_SEARCH_PLACEHOLDER } from "../texts";

export const getDropdownConfig = () => ({
    dropdownPopupHeight: 300,
    width: 320,
    searchPlaceholder: translate(KEYWORD_GROUP_SEARCH_PLACEHOLDER),
});

export const SEPARATOR_ITEM_FIRST = "my_list";
export const SEPARATOR_ITEM_SECOND = "shared_list";
